module.exports = __webpack_public_path__ + "img/fearofheightsthumb.8fbfa3f7.gif";